import AOS from 'aos';
import autosize from 'autosize';
import './scripts/jqueryLib';
import './scripts/trademark-search';

window.AOS = AOS;
window.autosize = autosize;

import './scripts/general';